import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-[#1A1A1A] text-[#FFF8F0] py-12 px-4 mt-auto" data-id="element-149">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8 text-center md:text-left" data-id="element-150">
        <div className="space-y-2" data-id="element-151">
          <h3 className="font-serif text-xl text-[#C5A55A]" data-id="element-152">
            Top Notch Bakery
          </h3>
          <p className="text-sm opacity-80" data-id="element-153">Est. 2021</p>
        </div>

        <div className="flex flex-col gap-3 text-sm opacity-90" data-id="element-154">
          <a href="https://maps.google.com/?q=Klostergatan+7,+Växjö" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center md:justify-start gap-2 hover:text-[#C5A55A] transition-colors" data-id="element-155">
            <MapPinIcon className="h-4 w-4 text-[#C5A55A]" data-id="element-156" />
            <span data-id="element-157">Klostergatan 7, Växjö</span>
          </a>
          <div className="flex items-center justify-center md:justify-start gap-2" data-id="element-158">
            <PhoneIcon className="h-4 w-4 text-[#C5A55A]" data-id="element-159" />
            <span data-id="element-160">0470-52 36 03</span>
          </div>
          <a href="mailto:info@topnotchbakery.se" className="flex items-center justify-center md:justify-start gap-2 hover:text-[#C5A55A] transition-colors" data-id="element-161">
            <MailIcon className="h-4 w-4 text-[#C5A55A]" data-id="element-162" />
            <span data-id="element-163">info@topnotchbakery.se</span>
          </a>
        </div>

        <div className="text-xs opacity-50" data-id="element-164">
          &copy; {new Date().getFullYear()} Top Notch Bakery.
        </div>
      </div>
    </footer>;
}